import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { Product } from "../types";
import { ColumnDef } from "@tanstack/react-table";
import DataTable from "@components/DataTable";
import CurrencyFormat from "react-currency-format";

function Add({
  products,
  selectedProductIds,
  setSelectedProductIds,
  setOnAddPage,
  currencyUnit,
}) {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [selectedProducts, setSelectedProducts] = useState<Product[]>(products);

  useEffect(() => {
    document.getElementById("selectedProduct0")?.focus();
  }, []);

  const productsTableColumns: ColumnDef<Product>[] = [
    {
      header: "* Qty",
      cell(props) {
        return (
          <Form.Control
            id={"selectedProduct" + props.row.index.toString()}
            readOnly={false}
            required={true}
            defaultValue={
              props.row.original.quantity ? props.row.original.quantity : 1
            }
            onBlur={(e) => {
              setSelectedProducts(
                selectedProducts.map((prod) => {
                  if (Number(prod.id) === Number(props.row.original.id)) {
                    prod = { ...prod, quantity: Number(e.target.value) };
                  }
                  return prod;
                })
              );
            }}
            type="number"
            min={1}
            step={1}
          />
        );
      },
    },
    {
      header: "Name/Description",
      cell(props) {
        return (
          <div className="displayFlex">{props.row.original.name}&nbsp;</div>
        );
      },
    },
    {
      header: "MFR Part",
      cell(props) {
        return <>{props.row.original.partNumber}</>;
      },
    },
    {
      header: "SKU",
      cell(props) {
        return <>{props.row.original.sku}</>;
      },
    },
    {
      header: "Int Prod Id",
      cell(props) {
        return <>{props.row.original.productId}</>;
      },
    },
    {
      header: "Units",
      cell(props) {
        return <>{props.row.original.units}</>;
      },
    },
    {
      header: "Category",
      cell(props) {
        return <>{props.row.original.category}</>;
      },
    },
    {
      header: "Unit Price",
      cell(props) {
        return (
          <CurrencyFormat
            displayType="text"
            prefix={currencyUnit}
            isNumericString={true}
            thousandSeparator={true}
            value={(props.row.original.unitPrice
              ? Number(props.row.original.unitPrice)
              : 0
            ).toFixed(2)}
          />
        );
      },
    },
  ];
  return (
    <div className="addProducts">
      <div className="addProductsCard">
        <div className="addProductsHeader">
          <div className="displayFlex">
            <Button
              className={"ssButtonBgWhite"}
              onClick={(e) => {
                setOnAddPage(false);
              }}
            >
              Back
            </Button>
            <h2>Review Selected Products</h2>
          </div>
          <Button
            className={`actionButton ${
              selectedProductIds.length === 0 ? "disabled" : ""
            }`}
          >
            Add&nbsp;
            <span>
              {selectedProductIds.length > 0 &&
                `(${selectedProductIds.length})`}
              &nbsp;
            </span>
            Products
          </Button>
        </div>
        <div className="instructionalText">
          * All Products must have a quantity to continue.
        </div>
        <DataTable
          data={
            selectedProducts?.length > 0
              ? selectedProducts
              : [
                  {
                    id: 0,
                    name: "No products found",
                    vendor: "",
                    partNumber: "",
                    productId: "",
                    units: "",
                    unitPrice: "",
                  },
                ]
          }
          columns={productsTableColumns}
          selectable={false}
          bordered
          striped
          hover
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          onPageSizeChange={setPageSize}
          selectedIds={selectedProductIds}
          setSelectedIds={setSelectedProductIds}
          paginationEnabled={false}
          pageSizeEnabled
        />
        <div className="text24 text-right">
          Sub-total:&nbsp;
          <CurrencyFormat
            displayType="text"
            prefix={currencyUnit}
            isNumericString={true}
            thousandSeparator={true}
            value={selectedProducts
              .map(
                (product) =>
                  Number(product.unitPrice ? product.unitPrice : 0) *
                  Number(product.quantity ? product.quantity : 1)
              )
              .reduce(function (accumulator, currentValue) {
                return accumulator + currentValue;
              }, 0)
              .toFixed(2)}
          />
        </div>
      </div>
    </div>
  );
}

export default Add;
